/**
 * Shared shape for `public.releases.items` (jsonb column, DB only enforces the
 * outer array shape — see backend/supabase/migrations/20260916120000_releases.sql).
 * A release is a curated bullet list an admin writes by hand: each entry is one
 * outcome the member can now see, grouped by kind on both this admin's Show page
 * and the mobile "What's New" screen.
 */
export type ReleaseItemKind = 'new' | 'improved' | 'fixed'

export interface ReleaseItem {
  kind: ReleaseItemKind
  text: string
}

export const RELEASE_ITEM_KIND_OPTIONS: { value: ReleaseItemKind; label: string }[] = [
  { value: 'new', label: 'New' },
  { value: 'improved', label: 'Improved' },
  { value: 'fixed', label: 'Fixed' },
]

export const RELEASE_ITEM_KIND_TAG_COLOR: Record<ReleaseItemKind, string> = {
  new: 'gold',
  improved: 'blue',
  fixed: 'green',
}

/** Order kinds always render in on the Show page and the member-facing screen. */
export const RELEASE_ITEM_KIND_ORDER: ReleaseItemKind[] = ['new', 'improved', 'fixed']

export const RELEASE_ITEM_KIND_GROUP_LABEL: Record<ReleaseItemKind, string> = {
  new: 'New',
  improved: 'Improved',
  fixed: 'Fixed',
}

/** Narrow an untyped `items` jsonb value down to a well-formed ReleaseItem[]. */
export function parseReleaseItems(value: unknown): ReleaseItem[] {
  if (!Array.isArray(value)) return []
  return value.filter(
    (v): v is ReleaseItem =>
      typeof v === 'object' &&
      v !== null &&
      typeof (v as Record<string, unknown>).text === 'string' &&
      RELEASE_ITEM_KIND_ORDER.includes((v as Record<string, unknown>).kind as ReleaseItemKind),
  )
}
